import React, { useState, useEffect, useCallback, useContext } from "react";

import FormDatosContacto from "./contacto/FormDatosContacto";
import FormDatosPersonales from "./FormDatosPersonales";
import FormDatosDeclaracionBienes from "./declaracionbienes/DeclaracionesBienes";
import FormDatosDocumentacion from "./documentacion/Documentaciones";
import FormDatosDomicilios from "./domicilio/Domicilios";
import FormDatosObservaciones from "./observacion/Observaciones";
import FormDatosLaborales from "./laboral/Laborales";
import FormDatosGarantes from "./garantes/Garantes";
import FormDatosCreditos from "./creditos/FromDatosCreditos";
import FormDatosHistorial from "./historial/FormDatosHistoriales";

import { clienteAxios, PersonasContext } from "../shared/";
import AnalisisFinanciero from "./analisisFinanciero/AnalisisFinanciero";
import AlertSuccess from "../CustomAlerts/AlertSuccess";
import GastosController from "./gastos/gastosController";
import "./styles/FormContenedor.css";

const FormContenedor = (props) => {
  const personaContext = useContext(PersonasContext);
  const { conseguirPersona, personaSeleccionada } = personaContext;
  //Vista solo lectura
  const [soloLectura, setSoloLectura] = useState(false);
  const [style, setStyle] = useState()

  const [key, setKey] = useState(1);
  const [maxkey, setMaxKey] = useState(1);
  const [id, setIdpersona] = useState(props.match.params.id);
  const [personaLoc] = useState({ id: null, persona: null });
  const [inicio, setInicio] = useState(true);

  useEffect(() => {
    if (window.location.pathname.startsWith("/clientes/ver/")) {
      setSoloLectura(true);
      /*
      setStyle({
        zIndex: 3,
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
      });
      */
    }

    const CargarDatosPersonales = async () => {
      if (!inicio) return;

      try {
        //setLoadingLocal(true);
        const result = await clienteAxios.get("/persona", { params: { id } });
        conseguirPersona(result.data);
        //console.log(result.data.persona.history);
        //setLoadingLocal(null);
      } catch (e) {
        //setLoadingLocal(null);
      }
    };
    setInicio(null);
    CargarDatosPersonales();
  }, [key, id]);

  const seleccionarTab = useCallback(
    (tab) => {
      setKey(tab);

      if (id) {
        setMaxKey(12);
      }
    },
    [id]
  );

  const SelectForm = () => {
    switch (key) {
      case 1:
        return (
          <FormDatosPersonales
            id={id}
            SetearIdPersona={SetearIdPersona}
            personaLoc={personaLoc}
            seleccionarTab={seleccionarTab}
            soloLectura={soloLectura}
          />
        );
      case 2:
        return <FormDatosContacto id={id} soloLectura={soloLectura} />;
      case 3:
        return <FormDatosDomicilios id={id} soloLectura={soloLectura} />;
      case 4:
        return <FormDatosLaborales id={id} soloLectura={soloLectura} />;
      case 5:
        return <FormDatosDocumentacion id={id} soloLectura={soloLectura} />;
      case 6:
        return <FormDatosDeclaracionBienes id={id} soloLectura={soloLectura} />;
      case 7:
        return <FormDatosObservaciones id={id} soloLectura={soloLectura} />;
      case 8:
        return <FormDatosGarantes id={id} soloLectura={soloLectura} />;
      case 9:
        return <FormDatosCreditos id={id} soloLectura={soloLectura} />;
      case 10:
        return <FormDatosHistorial id={id} soloLectura={soloLectura} />;
      case 11:
        return <AnalisisFinanciero id={id} />;
      case 12:
          return <GastosController id={personaSeleccionada.persona.nro_documento} />;
      default:
        return <>Se ha Producido un Error</>;
    }
  };

  const SetearIdPersona = async (id, persona) => {
    //console.log(id, persona);

    try {
      //setLoadingLocal(true);
      const result = await clienteAxios.get("/persona", { params: { id } });
      conseguirPersona(result.data);
      //console.log(result.data.persona.history);
      //setLoadingLocal(null);
    } catch (e) {
      //setLoadingLocal(null);
    }

    setIdpersona(id);
    /* setPersonaLoc({
      ...personaLoc,
      persona,
      id,
    }); */
  };

  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "generar-token":{
        let form = {
          id: id,
          token: 1
        }
        try {
          const response = await clienteAxios.put("/personas", form);
          return AlertSuccess({msg: "Token generado!"});
        } catch (error) {
          return "";
        }
      }break;
    }
  }

  const ver = props.match.path.split('/')[2] == "ver" ? true : false
  return (
    <div className="form-container-wrapper" style={style}>
      <div className="form-container-header">
        <h1 className="form-container-title">
          {
            !ver
            ? personaSeleccionada && id
            ? `Editar Cliente ${personaSeleccionada.persona.nombre} ${personaSeleccionada.persona.apellido}`
            : "Agregar Cliente"
            : personaSeleccionada && id
            ? `Cliente ${personaSeleccionada.persona.nombre} ${personaSeleccionada.persona.apellido}`
            : ""
          }
        </h1>
      </div>

      <div className="container-fluid">
        <div className="token-section d-none">
          <div className="input-group">
            <input
              type="text"
              className="form-control btn border text-muted rounded"
              style={{borderRadius: "0px"}}
              value={
                personaSeleccionada && id
                ? personaSeleccionada.persona.public_token
                ? "https://test.ayuu.com/cliente/publico/"+personaSeleccionada.persona.public_token
                : "No posee un token público"
                : "-"
              }
            />
            <label title="Generar Token Público" className="btn btn-primary input-group-text" id="basic-addon1">
              Generar nuevo token
              <i className="ms-1 bi bi-eye"></i>
              <button className="d-none" name="generar-token" onClick={(event) => onClick(event)}></button>
            </label>
          </div>
        </div>

        <div className="modern-tabs-nav">
          <button
            onClick={() => seleccionarTab(1)}
            className={`modern-tab-button ${key === 1 ? "active" : ""}`}
          >
            <i className="fa fa-user"></i>
            <span>Personales</span>
          </button>

          <button
            onClick={() => seleccionarTab(2)}
            className={`modern-tab-button ${key === 2 ? "active" : ""} ${maxkey > 1 ? "" : "disabled"}`}
          >
            <i className="fa fa-phone"></i>
            <span>Contacto</span>
          </button>

          <button
            onClick={() => seleccionarTab(3)}
            className={`modern-tab-button ${key === 3 ? "active" : ""} ${maxkey > 2 ? "" : "disabled"}`}
          >
            <i className="fa fa-home"></i>
            <span>Domicilios</span>
          </button>

          <button
            onClick={() => seleccionarTab(4)}
            className={`modern-tab-button ${key === 4 ? "active" : ""} ${maxkey > 3 ? "" : "disabled"}`}
          >
            <i className="fa fa-building"></i>
            <span>Laborales</span>
          </button>

          <button
            onClick={() => seleccionarTab(5)}
            className={`modern-tab-button ${key === 5 ? "active" : ""} ${maxkey > 4 ? "" : "disabled"}`}
          >
            <i className="fa fa-copy"></i>
            <span>Documentación</span>
          </button>

          <button
            onClick={() => seleccionarTab(6)}
            className={`modern-tab-button ${key === 6 ? "active" : ""} ${maxkey > 5 ? "" : "disabled"}`}
          >
            <i className="fa fa-car"></i>
            <span>Declaración de Bienes</span>
          </button>

          <button
            onClick={() => seleccionarTab(7)}
            className={`modern-tab-button ${key === 7 ? "active" : ""} ${maxkey > 6 ? "" : "disabled"}`}
          >
            <i className="fa fa-eye"></i>
            <span>Observaciones</span>
          </button>

          <button
            onClick={() => seleccionarTab(8)}
            className={`modern-tab-button ${key === 8 ? "active" : ""} ${maxkey > 7 ? "" : "disabled"}`}
          >
            <i className="fa fa-users"></i>
            <span>Garantes</span>
          </button>

          <button
            onClick={() => seleccionarTab(9)}
            className={`modern-tab-button ${key === 9 ? "active" : ""} ${maxkey > 8 ? "" : "disabled"}`}
          >
            <i className="fa fa-money"></i>
            <span>Créditos</span>
          </button>

          <button
            onClick={() => seleccionarTab(12)}
            className={`modern-tab-button ${key === 12 ? "active" : ""} ${maxkey > 11 ? "" : "disabled"}`}
          >
            <i className="fa fa-gavel"></i>
            <span>Gastos Judiciales</span>
          </button>

          <button
            onClick={() => seleccionarTab(10)}
            className={`modern-tab-button ${key === 10 ? "active" : ""} ${maxkey > 9 ? "" : "disabled"}`}
          >
            <i className="fa fa-history"></i>
            <span>Historial</span>
          </button>

          <button
            onClick={() => seleccionarTab(11)}
            className={`modern-tab-button ${key === 11 ? "active" : ""} ${maxkey > 10 ? "" : "disabled"}`}
          >
            <i className="fa fa-chart-line"></i>
            <span>Análisis Financiero</span>
          </button>
        </div>

        <div className="modern-tab-content">
          {SelectForm()}
        </div>
      </div>
    </div>
  );
};

export default FormContenedor;
